export default __webpack_public_path__ + "static/media/mute.0548420f.svg";